Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/victory-primitives/clip-path.js";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require("../victory-util/prop-types");

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _helpers = require("../victory-util/helpers");

var _helpers2 = _interopRequireDefault(_helpers);

var _collection = require("../victory-util/collection");

var _collection2 = _interopRequireDefault(_collection);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ClipPath = function (_React$Component) {
  _inherits(ClipPath, _React$Component);

  function ClipPath() {
    _classCallCheck(this, ClipPath);

    return _possibleConstructorReturn(this, (ClipPath.__proto__ || Object.getPrototypeOf(ClipPath)).apply(this, arguments));
  }

  _createClass(ClipPath, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      _extends(this, this.calculateAttributes(this.props));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var calculatedAttributes = this.calculateAttributes(nextProps);
      var _props = this.props,
          className = _props.className,
          clipId = _props.clipId,
          clipWidth = _props.clipWidth,
          translateX = _props.translateX,
          translateY = _props.translateY;

      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [clipId, nextProps.clipId], [clipWidth, nextProps.clipWidth], [translateX, nextProps.translateX], [translateY, nextProps.translateY], [this.x, calculatedAttributes.x], [this.y, calculatedAttributes.y], [this.height, calculatedAttributes.height], [this.width, calculatedAttributes.width]])) {
        _extends(this, calculatedAttributes);

        return true;
      }

      return false;
    }
  }, {
    key: "calculateAttributes",
    value: function calculateAttributes(props) {
      var _props$clipWidth = props.clipWidth,
          clipWidth = _props$clipWidth === undefined ? 0 : _props$clipWidth,
          _props$clipHeight = props.clipHeight,
          clipHeight = _props$clipHeight === undefined ? 0 : _props$clipHeight,
          _props$translateX = props.translateX,
          translateX = _props$translateX === undefined ? 0 : _props$translateX,
          _props$translateY = props.translateY,
          translateY = _props$translateY === undefined ? 0 : _props$translateY;

      var clipPadding = _helpers2.default.getPadding({
        padding: props.clipPadding
      });

      return {
        x: translateX - clipPadding.left,
        y: translateY - clipPadding.top,
        width: Math.max(clipWidth + clipPadding.left + clipPadding.right, 0),
        height: Math.max(clipHeight + clipPadding.top + clipPadding.bottom, 0)
      };
    }
  }, {
    key: "renderClipPath",
    value: function renderClipPath(props, id) {
      return _react2.default.createElement("defs", {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        }
      }, _react2.default.createElement("clipPath", {
        id: id,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        }
      }, _react2.default.createElement("rect", _extends({}, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67
        }
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          clipId = _props2.clipId,
          className = _props2.className;
      var clipProps = {
        className: className,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height
      };
      return this.renderClipPath(clipProps, clipId);
    }
  }]);

  return ClipPath;
}(_react2.default.Component);

ClipPath.propTypes = {
  className: _propTypes2.default.string,
  clipHeight: _propTypes4.default.nonNegative,
  clipId: _propTypes2.default.number,
  clipPadding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    top: _propTypes2.default.number,
    bottom: _propTypes2.default.number,
    left: _propTypes2.default.number,
    right: _propTypes2.default.number
  })]),
  clipWidth: _propTypes4.default.nonNegative,
  translateX: _propTypes2.default.number,
  translateY: _propTypes2.default.number
};
exports.default = ClipPath;